import { IPlatformDTO } from "./IPlatformDTO";
import { ICustomerDTO } from "./user-dto";

export type PlatformLogStatusTypes = "o" | "f" | "d";

export enum PlatformLogStatusEnum {
  ONLINE = "o",
  OFFLINE = "f",
  DEGRADED = "d",
}

export type PlatformLogWarningSentTypes = "t" | "f";

export enum PlatformLogWarningSentEnum {
  TRUE = "t",
  FALSE = "f",
}

export type PlatformLogPingTypes = "t" | "f";

export enum PlatformLogPingEnum {
  TRUE = "t",
  FALSE = "f",
}

export type PlatformLogContentLoadedTypes = "t" | "f";

export enum PlatformLogContentLoadedEnum {
  TRUE = "t",
  FALSE = "f",
}

export type PlatformLogTypeTypes = "a" | "m";

export enum PlatformLogTypeEnum {
  AUTO = "a",
  MANUAL = "m",
}

export interface IPlatformLogStatusDTO {
  status: PlatformLogStatusTypes;
  text: string;
  title: string;
  color: string;
}

export interface IPlatformLogDTO {
  id: number;
  platform: number;
  platformData?: IPlatformDTO;
  customer?: number;
  customerName?: string;
  customerData?: ICustomerDTO;
  type: PlatformLogTypeTypes;
  httpStatus: number;
  responseTime: number;
  ping: PlatformLogPingTypes;
  contentLoaded: PlatformLogContentLoadedTypes;
  message?: string;
  data: object;
  status: PlatformLogStatusTypes;
  createdAt?: Date;
}

export interface IPlatformLogListDTO {
  id: number;
  platform: number;
  platformData?: IPlatformDTO;
  customer?: number;
  customerName?: string;
  customerData?: ICustomerDTO;
  type: PlatformLogTypeTypes;
  warningSent: PlatformLogWarningSentTypes;
  httpStatus: number;
  responseTime: number;
  ping: PlatformLogPingTypes;
  contentLoaded: PlatformLogContentLoadedTypes;
  message?: string;
  data: object;
  status: PlatformLogStatusTypes;
  createdAt?: Date;
}

export interface IPlatformLogSWarningSentSelectDTO {
  type: PlatformLogWarningSentTypes;
  text: string;
}

export interface IPlatformLogStatusSelectDTO {
  status: PlatformLogStatusTypes;
  text: string;
}

export interface IPlatformLogTypeSelectDTO {
  type: PlatformLogTypeTypes;
  text: string;
}
